export enum BuilderTabType {
  Source = 'source',
  Form = 'form',
  Edit = 'edit',
  Review = 'review',
  Sign = 'sign',
  Finalize = 'finalize',
  Settings = 'settings',
}
